var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSolidSort(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_201_8989)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.4889 6.82569H11.0011C11.6365 6.82569 11.9742 6.07377 11.5517 5.59829L7.29603 0.81033C7.227 0.732414 7.14222 0.670034 7.04729 0.627312C6.95237 0.584591 6.84945 0.5625 6.74536 0.5625C6.64126 0.5625 6.53835 0.584591 6.44342 0.627312C6.3485 0.670034 6.26372 0.732414 6.19469 0.81033L1.93749 5.59829C1.51509 6.07377 1.85271 6.82569 2.4889 6.82569ZM6.19395 14.3147C6.26298 14.3926 6.34776 14.455 6.44269 14.4977C6.53761 14.5404 6.64052 14.5625 6.74462 14.5625C6.84872 14.5625 6.95163 14.5404 7.04655 14.4977C7.14148 14.455 7.22626 14.3926 7.29529 14.3147L11.551 9.52671C11.9742 9.05197 11.6365 8.30005 11.0003 8.30005H2.4889C1.85345 8.30005 1.51582 9.05197 1.93823 9.52744L6.19395 14.3147Z",
    fill: "#AEB5BC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_201_8989"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0 0.5625)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSolidSort);
export default __webpack_public_path__ + "static/media/icon-solid-sort.c91eabf7.svg";
export { ForwardRef as ReactComponent };